import { Component, OnInit, ViewChild } from '@angular/core'
import { HouseholdProfilesService } from '@se-po/shared-data-access-services'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'
import { UserProfile } from 'se-resource-types/dist/lib/CentralService/Households'
import { ProfileSidePanelComponent } from '../../lib/profile-side-panel/profile-side-panel.component'

const exampleHtml = `
<div>
  <se-fe-button seFeDataEmphasis="high" (click)="showSidePanel = true">Open Side Panel</se-fe-button>
  <se-po-profile-side-panel
    #profileSidePanel
    [profile]="profile"
    (avatarClicked)="onAvatarClick()"
    [(showSidePanel)]="showSidePanel"
    [menuOptions]="menuOptions">
    <div profileSidePanelContent>
      Side Panel Content
    </div>
  </se-po-profile-side-panel>
</div>
`

const exampleTypescript = `
import { Component, OnInit, ViewChild } from '@angular/core'
import { HouseholdProfilesService } from '@se-po/shared-data-access-services'
import { UserProfile } from 'se-resource-types/dist/lib/CentralService/Households'
import { ProfileSidePanelComponent } from '../../lib/profile-side-panel/profile-side-panel.component'

export class ProfileSidePanelExampleComponent implements OnInit  {
  public profile: UserProfile
  public menuOptions = {
    name: 'profileSidePanelMenu',
    sections: [{ menuItems: [{ text: 'Edit Profile', action: () => console.log('Edit Profile') }] }]
  }
  public showSidePanel = false

  constructor(
    private householdProfilesService: HouseholdProfilesService
  ) {
    super()
  }

  public ngOnInit(): void {
    this.householdProfilesService.find('59707602').subscribe(profile => {
      this.profile = profile
    })
  }

  public onAvatarClick(): void {
    console.log('avatar clicked')
  }
}
`

const template = `<se-fe-docs-example [example]="this">${exampleHtml}</se-fe-docs-example>`

@Component({
  selector: 'se-po-profile-side-panel-example',
  template,
  styleUrls: ['./profile-side-panel-docs.component.scss'],
  standalone: false,
})
export class ProfileSidePanelExampleComponent extends SeFeDocsExampleComponent implements OnInit {
  @ViewChild('profileSidePanel') profileSidePanel: ProfileSidePanelComponent
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]

  public profile: UserProfile
  public menuOptions = {
    name: 'profileSidePanelMenu',
    sections: [{ menuItems: [{ text: 'Edit Profile', action: () => console.log('Edit Profile') }] }]
  }
  public showSidePanel = false

  constructor(
    private householdProfilesService: HouseholdProfilesService
  ) {
    super()
  }

  public ngOnInit(): void {
    this.householdProfilesService.find('59707602').subscribe(profile => {
      this.profile = profile
    })
  }

  public onAvatarClick(): void {
    console.log('avatar clicked')
  }
}
